// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  renditionId: __t.u64(),
  offsetX: __t.f64(),
  offsetY: __t.f64(),
  offsetZ: __t.f64(),
  yawDeg: __t.f64(),
  pitchDeg: __t.f64(),
  rollDeg: __t.f64(),
  scaleX: __t.f64(),
  scaleY: __t.f64(),
  scaleZ: __t.f64(),
};
